import { motion } from "framer-motion";
import React from "react";
import { IconType } from "react-icons";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";
import { twMerge } from "tailwind-merge";
export interface AccordianPropsModel {
  header: string | JSX.Element;
  body: string | JSX.Element;
  handleClick: () => void;
  isOpen: boolean;
  bodyWrapperClassName?: string;
  openIcon?: IconType;
  closeIcon?: IconType;
  wrapperClassName?: string;
  headerClassName?: string;
  hideIcon?: boolean;
}
const Accordian: React.FunctionComponent<AccordianPropsModel> = ({
  header,
  body,
  isOpen,
  bodyWrapperClassName = "",
  handleClick,
  openIcon,
  closeIcon,
  wrapperClassName = "",
  headerClassName = "",
  hideIcon,
}) => {
  const isBodyString = typeof body === "string";
  const dynamicClassName = isOpen
    ? "text-primary-orange-50"
    : "text-dark-purple-50";

  const IconOpen = openIcon ?? FiPlusCircle;
  const IconClose = closeIcon ?? FiMinusCircle;

  const handleTitleClick = () => {
    handleClick();
  };

  const renderIcons = () => {
    if (hideIcon) return <></>;
    return (
      <span className="h-full flex items-center pl-1 pt-1">
        {isOpen ? <IconClose /> : <IconOpen />}
      </span>
    );
  };

  const renderBody = () => {
    if (isBodyString) {
      return (
        <motion.div
          dangerouslySetInnerHTML={{ __html: body }}
          className={twMerge(
            "overflow-hidden !text-sm xl:!text-base",
            bodyWrapperClassName
          )}
          animate={{
            height: isOpen ? "auto" : "0px",
            marginTop: isOpen ? 22 : 0,
          }}
        />
      );
    }
    return (
      <motion.div
        className={twMerge("overflow-hidden", bodyWrapperClassName)}
        animate={{
          height: isOpen ? "auto" : "0px",
        }}
      >
        {body}
      </motion.div>
    );
  };

  return (
    <div className={twMerge("border-b p-4 xl:py-9 xl:px-0", wrapperClassName)}>
      <div
        className={twMerge(
          "font-semibold tracking-[-0.48px] flex justify-between items-center cursor-pointer text-base xl:text-2xl ",
          dynamicClassName,
          headerClassName
        )}
        onClick={handleTitleClick}
        role="button"
      >
        <span>{header}</span>
        {renderIcons()}
      </div>
      {renderBody()}
    </div>
  );
};
export default Accordian;
